// The Library at phone width, exactly as PhoneLibrary.dc.html: the same sections, stacked, with
// rows in place of tiles, and Free webinars as Adam's of 9 Oct (Webinars.jsx). Coming up's Join and
// Add to calendar are design 5.3's and the sign-off's; the board draws neither. Next up has Join
// too, from 15 minutes before its session until the end, above the board's button, and the Coming
// up card for that same session leaves out Add to calendar, which Next up already has (Adam, 3 Oct).
// After the hub's own In progress rows come the portal cards' rows (Adam, 10 Oct), each opening its
// own site in a new tab.
import { Link } from '../lib/router.jsx'
import { readOnlyControl } from '../lib/viewAs.jsx'
import { PhoneArt } from './Art.jsx'
import { CloseIcon } from '../shell/Marks.jsx'
import { OutArrow } from '../free/Icons.jsx'
import { FreeGlyph } from './FreeGlyph.jsx'
import { useCovers } from '../free/covers.js'
import { SessionActions, calLabel } from './LibraryLaptop.jsx'
import { DateBlock } from './DateBlock.jsx'
import { LibraryWebinars } from './Webinars.jsx'

function Row({ tile }) {
  const inside = (
    <>
      <PhoneArt tile={tile} />
      <span className="prow-body">
        <span className="prow-name">{tile.name}</span>
        {tile.status && tile.level && (
          // where they stand, then the status, on 1 line (levels.js)
          <span className="prow-line">
            <span className={`tile-level tile-level--${tile.level.key}`}>{`${tile.level.word}.`}</span>{' '}
            <span className="prow-status">{tile.status}</span>
          </span>
        )}
        {tile.status && !tile.level && (
          <span className={tile.strong ? 'prow-status prow-status--strong' : tile.external ? 'prow-status prow-status--out' : 'prow-status'}>
            {tile.status}{tile.external && <OutArrow size={13} />}
          </span>
        )}
        {tile.pct != null && <span className="bar bar--phone"><span className="bar-fill" style={{ width: `${tile.pct}%` }} /></span>}
        {tile.pctLabel && <span className="tile-pct">{tile.pctLabel}</span>}
        {tile.external && <span className="sr-only"> (opens in a new tab)</span>}
      </span>
    </>
  )
  // a portal card: the product's own site, in a new tab, where they log in as they do today (Adam, 10 Oct)
  if (tile.external) return <a href={tile.href} target="_blank" rel="noopener noreferrer" className="prow">{inside}</a>
  return <Link to={tile.href} className="prow">{inside}</Link>
}

export default function LibraryPhone({ model, onHide, onAddCal, added, viewingAs, note }) {
  const m = model
  const covers = useCovers(m.freebies)
  const tiles = m.inProgress.length + m.startingSoon.length
  return (
    <main className="ph-main">
      {note && <div className="ph-note">{note}</div>}
      <section className="ph-hello">
        <span className="ph-date">{m.dateLine}</span>
        <span className="ph-h1">{m.greeting}</span>
      </section>

      {m.announcement && (
        <section aria-label="Announcement" className="ph-news">
          <div className="ph-news-top">
            <span className="ph-news-from">{m.announcement.from}</span>
            <button type="button" className="ph-news-hide" aria-label="Hide this announcement" onClick={() => onHide(m.announcement.id)} {...readOnlyControl(viewingAs)}><CloseIcon /></button>
          </div>
          <span className="ph-news-head">{m.announcement.headline}</span>
          {m.announcement.line && <span className="ph-news-line">{m.announcement.line}</span>}
          {m.announcement.button && <Link to={m.announcement.button.href} className="ph-btn ph-btn--news">{m.announcement.button.label}</Link>}
        </section>
      )}

      {m.nextUp && (
        <section className="ph-next">
          <span className="ph-next-eyebrow"><span className={`dot dot--small dot--${m.nextUp.accent}`} />Next up</span>
          <span className="ph-next-title">{m.nextUp.title}</span>
          <span className="ph-next-line">{m.nextUp.phoneLine || m.nextUp.line}</span>
          {m.nextUp.join && (
            <a href={m.nextUp.join.href} target="_blank" rel="noopener noreferrer" className="ph-btn ph-btn--next" aria-label={m.nextUp.join.label}>Join</a>
          )}
          {/* while Join shows, it's the 1 black button */}
          <Link to={m.nextUp.button.href} className={m.nextUp.join ? 'ph-btn ph-btn--line' : 'ph-btn ph-btn--next'}>{m.nextUp.button.label}</Link>
          {m.nextUp.calendar && (
            <button type="button" className="ph-btn-line" onClick={() => onAddCal(m.nextUp.calendar)}>
              {calLabel(added.has(m.nextUp.calendar.uid))}
            </button>
          )}
        </section>
      )}

      {m.comingUp.length > 0 && (
        <section className="ph-section">
          <h2 className="ph-h2 ph-h2--gap">Coming up</h2>
          {m.comingUp.map(s => (
            <div key={s.id} className="ph-session ph-session--card">
              <div className="ph-session-top">
                <DateBlock block={s.block} small />
                <span className="ph-session-text">
                  <span className="ph-session-product"><span className={`dot dot--small dot--ring dot--${s.accent}`} />{s.product}</span>
                  <span className="ph-session-title">{s.title}</span>
                  <span className="ph-session-time">{s.phoneTime}</span>
                </span>
              </div>
              <SessionActions session={s} added={added.has(s.id)} onAddCal={onAddCal} className="ph-session-actions" />
            </div>
          ))}
        </section>
      )}

      {m.inProgress.length > 0 && (
        <section className="ph-section ph-section--tiles">
          <h2 className="ph-h2">In progress</h2>
          {m.inProgress.map(t => <Row key={t.id} tile={t} />)}
          {m.joinLine && m.startingSoon.length === 0 && <p className="ph-join">Everything you join shows up here.</p>}
        </section>
      )}

      {m.startingSoon.length > 0 && (
        <section className="ph-section ph-section--tiles">
          <h2 className="ph-h2">Starting soon</h2>
          {m.startingSoon.map(t => <Row key={t.id} tile={t} />)}
          {m.joinLine && <p className="ph-join">Everything you join shows up here.</p>}
        </section>
      )}
      {m.joinLine && tiles === 0 && <p className="ph-join ph-join--alone">Everything you join shows up here.</p>}

      {m.forLife.length > 0 && (
        <section className="ph-section ph-section--tiles" aria-label="Yours for life">
          <h2 className="ph-h2">Yours for life</h2>
          {m.forLife.map(t => <Row key={t.id} tile={t} />)}
        </section>
      )}

      <LibraryWebinars webinars={m.webinars} phone />

      {m.freebies.length > 0 && (
        <section className="ph-section">
          <div className="ph-section-head">
            <h2 className="ph-h2">Free resources</h2>
            <Link to="/free-resources" className="ph-all">See all</Link>
          </div>
          {m.freebies.map(fr => (
            <Link key={fr.id} to="/free-resources" className="ph-free">
              <FreeGlyph item={fr} covers={covers} small />
              <span className="ph-free-text">
                <span className="ph-free-name">{fr.name}</span>
                <span className="ph-action">{fr.action}</span>
              </span>
            </Link>
          ))}
        </section>
      )}
    </main>
  )
}
